<template>
  <div class="select-video">
    <vh-dialog
      :title="$t('lang.k_290001')"
      @closed="closeHandler"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      width="800px"
    >
      <div class="search" v-show="total || isSearch">
        <vh-input
          :placeholder="$t('lang.k_290002')"
          v-model="keyWords"
          v-clearEmoij
          @keyup.enter.native="searchHandler"
          clearable
          @clear="searchHandler"
          round
        >
          <i class="vh-icon-search vh-input__icon" @click="searchHandler" slot="prefix"></i>
        </vh-input>
        <!-- <i class="iconfont-v3 saasicon_help_m"></i> -->
        <span class="select-video_tip" v-if="isWarmVideo">{{ $t('lang.k_290003') }}</span>
        <!-- prettier-ignore -->
        <span class="select-video_tip" v-else>{{ $t('lang.k_290004') }}<span v-if="webinarType==='time'">{{ $t('lang.k_290005') }}</span>
      </span>
        <vh-button type="primary" @click="uploadHandler" round size="medium">
          {{ $t('lang.k_290006') }}
        </vh-button>
      </div>
      <div v-if="total || isSearch" style="min-height: 300px">
        <vh-table
          ref="docList"
          :data="docList"
          tooltip-effect="dark"
          style="width: 100%"
          max-height="300"
          v-loadMore="moreLoadData"
          :class="[{ 'is-vod': isVodVideo }]"
          @select="handleSelection"
          @select-all="handleAllSelection"
          @selection-change="handleSelectionChange"
        >
          <vh-table-column type="selection" width="60"></vh-table-column>
          <vh-table-column show-overflow-tooltip :label="$t('lang.k_290007')" minWidth="160px">
            <template slot-scope="scope">
              <span class="mediaName">
                <i
                  class="iconfont-v3 saasyinpinwenjian"
                  v-if="scope.row.msg_url == '.MP3' || scope.row.msg_url == '.MAV'"
                ></i>
                <i class="iconfont-v3 saasshipinwenjian" v-else></i>
                {{ scope.row.name }}
              </span>
            </template>
          </vh-table-column>
          <vh-table-column :label="$t('lang.k_290008')" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.created_at.substring(0, 16) }}</span>
            </template>
          </vh-table-column>

          <vh-table-column
            :label="$t('lang.k_290009')"
            prop="duration"
            width="90"
            show-overflow-tooltip
          ></vh-table-column>

          <vh-table-column :label="$t('lang.k_290010')" width="110" show-overflow-tooltip>
            <template slot-scope="scope">
              <span
                class="statusTag"
                :class="scope.row.transcode_status == 1 ? 'success' : 'failer'"
              >
                {{ scope.row.transcode_status_text }}
              </span>
            </template>
          </vh-table-column>

          <vh-table-column
            v-if="isWarmVideo"
            :label="$t('lang.k_290011')"
            prop="storage"
            width="120"
            show-overflow-tooltip
          ></vh-table-column>

          <vh-table-column
            :label="$t('lang.k_290012')"
            width="110"
            align="left"
            show-overflow-tooltip
            fixed="right"
          >
            <template slot-scope="scope">
              <vh-button
                type="text"
                class="actionBtn"
                @click="preVidio(scope.row)"
                v-if="scope.row.transcode_status == 1"
              >
                {{ $t('lang.k_290013') }}
              </vh-button>
            </template>
          </vh-table-column>
          <div slot="empty"><noData :nullType="'search'" v-if="!total" :height="50"></noData></div>
        </vh-table>
      </div>
      <div class="no-live" v-else>
        <noData :nullType="'nullData'" :text="$t('lang.k_290014')" :height="0">
          <vh-button type="primary" @click="uploadHandler" round size="medium">
            {{ $t('lang.k_290006') }}
          </vh-button>
        </noData>
      </div>
      <div slot="footer" class="dialog-footer" v-show="total || isSearch">
        <div>
          <p v-show="!isVodVideo">
            <i18n path="lang.k_290015">
              <template>
                <b>{{ isWarmVideo ? totalWarmSelect.length : tableSelect.length }}</b>
              </template>
            </i18n>
          </p>
        </div>
        <span>
          <vh-button type="info" @click="closeDialog" round plain size="medium">
            {{ $t('lang.k_290017') }}
          </vh-button>
          <vh-button
            type="primary"
            @click="handlerConfirm"
            :disabled="isWarmVideo ? !totalWarmSelect.length : !tableSelect.length"
            round
            size="medium"
            v-preventReClick
          >
            {{ $t('lang.k_290018') }}
          </vh-button>
        </span>
      </div>
    </vh-dialog>
    <template v-if="showDialog">
      <vh-dialog
        class="vh-saas-dialog"
        title=""
        :visible.sync="showDialog"
        width="30%"
        center
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <video-preview ref="videoPreview" :videoParam="videoParam"></video-preview>
      </vh-dialog>
    </template>
  </div>
</template>

<script>
  import VideoPreview from '../MaterialModule/VideoPreview/index.vue';
  import noData from '@/views/PlatformModule/Error/nullPage';
  import { isEmbed } from '../../utils/utils';
  export default {
    props: {
      videoSize: {
        type: String,
        default: ''
      },
      videoType: {
        type: String,
        default: ''
      },
      selectedList: {
        type: Array,
        default: () => []
      },
      isWarmVideo: {
        type: Boolean,
        default: false
      },
      isVodVideo: {
        type: Boolean,
        default: false
      },
      webinarType: {
        type: String,
        default: ''
      },
      // 最小视频时长限制（单位秒），0-不限制
      minDuration: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        dialogVisible: false,
        showDialog: false,
        videoParam: {},
        docList: [],
        total: 0,
        isSearch: false, //是否是搜索
        pageInfo: {
          pos: 0,
          limit: 6,
          pageNum: 1
        },
        totalPages: 0,
        totalWarmSelect: [],
        tableSelect: [],
        keyWords: ''
      };
    },
    components: {
      VideoPreview,
      noData
    },
    watch: {
      dialogVisible() {
        //获取资料中心的音视频
        if (this.dialogVisible) {
          this.tableSelect = [];
          this.docList = [];
          this.pageInfo.pageNum = 1;
          this.pageInfo.pos = 0;
          this.getMediaList();
          if (this.isWarmVideo) {
            this.totalWarmSelect = JSON.parse(JSON.stringify(this.selectedList || []));
          }
        } else {
          this.keyWords = '';
          this.pageInfo.pageNum = 1;
          this.pageInfo.pos = 0;
          this.totalWarmSelect = [];
          if (this.docList.length) {
            this.$refs.docList.clearSelection();
          }
        }
      }
    },
    methods: {
      //字数截断显示省略号
      fontNumber(date) {
        const length = date.length;
        const format = date.substring(date.length - 4, date.length);
        if (length > 13) {
          var str = '';
          str = date.substring(0, 13) + '...' + format;
          return str;
        } else {
          return date;
        }
      },
      closeDialog() {
        if (this.docList.length) {
          this.$refs.docList.clearSelection();
        }
        this.dialogVisible = false;
        this.totalWarmSelect = [];
        this.pageInfo.pageNum = 1;
        this.pageInfo.pos = 0;
      },
      handleClose(done) {
        if (this.docList.length) {
          this.$refs.docList.clearSelection();
        }
        this.dialogVisible = false;
        this.totalWarmSelect = [];
        this.pageInfo.pageNum = 1;
        this.pageInfo.pos = 0;
        done();
      },
      moreLoadData() {
        if (this.pageInfo.pageNum >= this.totalPages) {
          return false;
        }
        this.pageInfo.pageNum++;
        this.pageInfo.pos = parseInt((this.pageInfo.pageNum - 1) * this.pageInfo.limit);
        this.getMediaList();
      },
      getMediaList() {
        let params = {
          title: this.keyWords,
          storage: this.videoSize,
          file_type: this.videoType,
          get_no_trans: 1,
          ...this.pageInfo
        };
        if (this.minDuration > 0) {
          params.min_duration = this.minDuration;
        }
        this.$fetch('dataVideoList', this.$params(params)).then(res => {
          if (res.code == 200) {
            // 转码状态:0新增排队中 1转码成功 2转码失败 3转码中
            res.data.list.forEach(ele => {
              switch (ele.transcode_status) {
                case '0':
                  ele.transcode_status_text = this.$t('lang.k_290019');
                  ele.duration = '——';
                  break;
                case '1':
                  ele.transcode_status_text = this.$t('lang.k_290020');
                  break;
                case '2':
                  ele.transcode_status_text = this.$t('lang.k_290021');
                  ele.duration = '——';
                  break;
                case '3':
                  ele.transcode_status_text = this.$t('lang.k_290022');
                  ele.duration = '——';
                  break;
                default:
                  ele.transcode_status_text = this.$t('lang.k_290019');
                  ele.duration = '——';
                  break;
              }
            });
            this.docList.push(...res.data.list);
            this.total = res.data.total;
            this.totalPages = Math.ceil(res.data.total / this.pageInfo.limit);
            this.isSearch = this.keyWords ? true : false;
            if (this.isWarmVideo && this.docList.length) {
              this.selectedDefaultList();
            }
          }
        });
      },
      // 默认选中
      selectedDefaultList() {
        this.$nextTick(() => {
          if (this.totalWarmSelect.length) {
            let selectedList = [];
            selectedList = this.totalWarmSelect.map(item => {
              return item.paas_record_id;
            });
            // 如果返回的列表已经选过，就默认选中
            this.docList.forEach(item => {
              if (selectedList.includes(item.paas_record_id)) {
                this.$nextTick(() => {
                  this.$refs.docList.toggleRowSelection(item, true);
                });
              }
            });
          }
        });
      },
      preVidio(rows) {
        this.videoParam = rows;
        this.showDialog = true;
        console.log(rows);
      },
      // 单选
      handleSelection(val, item) {
        console.log('handleSelection val:', val);
        if (!this.isWarmVideo || this.selectedList.length == 0) return;
        // 如果是暖场视频并且已经选过暖场视频，才走下面的选中逻辑
        console.log(this.selectedList, item);
        let selectedList = [];
        selectedList = this.totalWarmSelect.map(item => {
          return item.paas_record_id;
        });
        if (selectedList.includes(item.paas_record_id)) {
          // 如果列表存在这个选择的项，就证明取消了选择， 就过滤掉这个
          this.totalWarmSelect = this.totalWarmSelect.filter(
            items => items.paas_record_id != item.paas_record_id
          );
        } else {
          // 如果列表不存在这个选择的项，就证明是新增了
          this.totalWarmSelect.push(item);
        }
      },
      // 全选和取消全选
      handleAllSelection(val) {
        console.log('handleAllSelection val:', val);
        if (!this.isWarmVideo || this.selectedList.length == 0) return;
        // 如果是暖场视频并且已经选过暖场视频，才走下面的选中逻辑
        let selectedList = [];
        selectedList = this.totalWarmSelect.map(item => {
          return item.paas_record_id;
        });
        if (val.length) {
          //如果存在长度，就是全选，然后把列表不存在的都加上
          this.docList.forEach(item => {
            if (!selectedList.includes(item.paas_record_id)) {
              this.totalWarmSelect.push(item);
            }
          });
        } else {
          // 如果不存在长度，就是全都不选，把音视频列表所有的数据去过滤了，只留不存在视频列表的数据
          this.docList.forEach(item => {
            if (selectedList.includes(item.paas_record_id)) {
              this.totalWarmSelect = this.totalWarmSelect.filter(
                items => items.paas_record_id != item.paas_record_id
              );
            }
          });
        }
      },
      // 选择框变化
      handleSelectionChange(val) {
        this.tableSelect = val;
        if (this.isVodVideo) {
          // 如果是点播或者定时直播、默认只能选择一个
          this.docList.forEach(item => {
            if (val.length !== 0) {
              if (item.paas_record_id !== val[[val.length - 1]].paas_record_id) {
                this.$refs.docList.toggleRowSelection(item, false);
              }
            }
          });
        }
        // 如果暖场视频一个视频都没选择过，选择框变化就是选中的数据
        if (this.isWarmVideo && this.selectedList.length == 0) {
          this.totalWarmSelect = val;
        }
      },
      handlerConfirm() {
        // if (this.tableSelect[0].transcode_status != 1) {
        //   this.$vhMessage({
        //     message: "只能选择已经转码成功的视频",
        //     showClose: true,
        //     // duration: 0,
        //     type: 'error',
        //     customClass: 'zdy-info-box'
        //   });
        //   return;
        // }
        if (this.isWarmVideo) {
          if (this.totalWarmSelect.length > 10) {
            this.$vhMessage.warning(this.$t('lang.k_290023'));
            return;
          }
          this.$emit('selected', this.totalWarmSelect);
        } else {
          if (this.isVodVideo) {
            // 如果是点播或者定时直播、默认只能选择第一个
            this.$emit('selected', this.tableSelect[0]);
          } else {
            let tableList = [];
            this.tableSelect.map(item => {
              tableList.push(item.id);
            });
            // 如果是插播、只要id
            this.$emit('selected', tableList);
          }
        }
        this.dialogVisible = false;
      },
      closeHandler() {
        // clearSelection
        // this.tableSelect
      },
      searchHandler() {
        this.pageInfo.pageNum = 1;
        this.pageInfo.pos = 0;
        this.docList = [];
        this.getMediaList();
      },
      uploadHandler() {
        this.$vhConfirm(this.$t('lang.k_290024'), this.$t('lang.k_290025'), {
          confirmButtonText: this.$t('lang.k_290018'),
          cancelButtonText: this.$t('lang.k_290017'),
          customClass: 'zdy-message-box',
          lockScroll: false,
          roundButton: true,

          cancelButtonClass: 'zdy-confirm-cancel'
        })
          .then(() => {
            this.$parent.isChange = false;
            this.$parent.warmFlag = false;
            this.$emit('closeWarm');
            this.$router.push({ path: `${isEmbed() ? '/embed' : ''}/material/video` });
          })
          .catch(() => {});
      }
    }
  };
</script>
<style lang="less" scoped>
  @red: #fb3a32;
  @redBg: #ffebeb;

  // 点播和定时直播只能单选视频，ui优化
  ::v-deep .vh-table.is-vod {
    .vh-table-column--selection {
      .vh-checkbox__inner {
        border-radius: 50%;
      }
    }
    th.vh-table-column--selection .vh-checkbox {
      display: none;
    }
  }

  ::v-deep .vh-table__empty-block {
    height: 220px !important;

    .null-info {
      line-height: 1;
    }
    .null-page.null-page--search {
      margin-top: 0 !important;
    }
    .null-page--search .search {
      margin-top: 0 !important;
      transform: none;
    }
  }

  .select-video {
    max-width: 800px;
    .vh-dialog {
      max-width: 800px;
    }
  }
  .saasicon_help_m {
    padding-left: 5px;
    font-size: 15px;
    color: #999;
  }
  .select-video_tip {
    color: #999;
    padding-left: 5px;
    font-size: 14px;
    vertical-align: text-top;
    width: 400px;
    display: inline-block;
  }
  .statusTag {
    &::before {
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 6px;
    }
    &.wating::before {
      background: #fa9a32;
    }
    &.success::before {
      background: #14ba6a;
    }
    &.failer::before {
      background: #fb3a32;
    }
  }
  .mediaName {
    font-size: 14px;
    color: #1a1a1a;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .iconfont-v3 {
      font-size: 20px;
      margin-top: -3px;
    }
    .saasyinpinwenjian {
      color: #10d3a8;
      // padding-right: 2px;
    }
    .saasshipinwenjian {
      color: #ff733c;
      // padding-right: 2px;
    }
    i {
      display: inline-block;
      width: 20px;
      height: 20px;
      // background: #10D3A8;
      border-radius: 4px;
      // margin-right: 12px;
      vertical-align: middle;
    }
  }

  .search {
    margin-bottom: 16px;
    .vh-input {
      width: 220px;
    }
    .vh-button {
      float: right;
    }
  }
  // .vh-saas-dialog {}
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    p {
      font-size: 14px;
      color: #666;
      line-height: 36px;
      b {
        color: #fb3a32;
        font-weight: normal;
      }
    }
  }
</style>
